import { render } from "./Calendar.vue?vue&type=template&id=53393a84&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=53393a84&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53393a84"]])

export default __exports__